import _object_spread from "@swc/helpers/src/_object_spread.mjs";
import _object_spread_props from "@swc/helpers/src/_object_spread_props.mjs";
import { jsx as _jsx } from "react/jsx-runtime";
import { useEffect, useState } from "react";
import { SearchGrid, StoryDataContent } from "@vfit/shared/components";
var TITLE = "<h2>Trova le tue <b>Stories Preferite</b></h2>";
var FindYourStories = function(param) {
    var storiesArticles = param.storiesArticles;
    var ref = useState(storiesArticles), filteredList = ref[0], setFilteredList = ref[1];
    var ref1 = useState(), topics = ref1[0], setTopics = ref1[1];
    var toggleTopic = function(selectedTopic) {
        return setTopics(function(prevTopics) {
            return prevTopics === null || prevTopics === void 0 ? void 0 : prevTopics.map(function(topic) {
                if (topic.label === selectedTopic.label && !topic.isSelected) {
                    return _object_spread_props(_object_spread({}, topic), {
                        isSelected: true
                    });
                }
                return _object_spread_props(_object_spread({}, topic), {
                    isSelected: false
                });
            });
        });
    };
    useEffect(function() {
        if (!topics && filteredList && filteredList.length > 0) {
            var topicsMap = new Map();
            filteredList.map(function(el) {
                return el.topic && topicsMap.set(el.topic, {
                    label: el.topic,
                    isSelected: el.topic === "Novit\xe0"
                }) // TODO: change with el.isSelected
                ;
            });
            var topicsList = [];
            topicsMap.forEach(function(value, key) {
                if (key) topicsList.push(value);
            });
            setTopics(topicsList);
        }
    }, []);
    useEffect(function() {
        var activeTopics = topics === null || topics === void 0 ? void 0 : topics.filter(function(topic) {
            return topic.isSelected;
        }).map(function(topic) {
            return topic.label;
        });
        if (activeTopics && activeTopics.length > 0) {
            var filtered = storiesArticles && storiesArticles.length > 0 && storiesArticles.filter(function(story) {
                return story && story.topic && activeTopics.includes(story.topic);
            });
            if (filtered && filtered.length > 0) {
                setFilteredList(filtered);
            } else {
                setFilteredList(filteredList);
            }
        } else {
            // If no active topics
            setFilteredList([]);
        }
    }, [
        topics
    ]);
    return /*#__PURE__*/ _jsx(SearchGrid, {
        elements: StoryDataContent(filteredList),
        title: TITLE,
        tags: topics,
        toggleTags: toggleTopic
    });
};
export default FindYourStories;
